import {Component, Input, QueryList, ViewChildren} from '@angular/core';
import {User} from '@models/user/user';
import {
  SortEvent,
  TableHeaderSortableDirective
} from '@shared/table-header-sortable/table-header-sortable.directive';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'scitis-admin-organization-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: false
})
export class UsersComponent {

  @Input()
  users: User[] = new Array<User>();

  @Input()
  organizationName: string = '';

  constructor(private tableHeaderSortableService: TableHeaderSortableService,
              public translate: TranslateService) {
  }


  //SORTING
  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  onColumnSort({column, direction}: SortEvent) {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.users = this.tableHeaderSortableService.sortItems<User>(this.users, column, direction);
  }
}
